const styles = (theme) => ({
  containerTitle: { width: "100%", textAlign: "center" },
  containerComponente: {
    display: "flex",
    width: "100%",

    borderRadius: 2,
    overflow: "visible",
  },
  boxGraph: {
    transition: "all 0.25s ease-in-out",
    borderRadius: 1,
    cursor: "pointer",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0px 6px 12px rgba(0,0,0,0.35)",
      borderRadius: 2,
      zIndex: 3,
    },
  },
  titleComponent: {
    fontWeight: "bold",
    mb: 1,
  },
  titleTooltip: {
    fontWeight: "bold",
    fontSize: "12px",
  },
  countTooltip: {
    fontWeight: "bold",
    fontSize: "10px",
  },
});

export default styles;
